import React, {useEffect, useState} from "react";

import { useParams } from "react-router";
import {useUser} from "../../store/providers/app";
import {getProfile} from "../../utils";
import format from "date-fns/format";
import ptBR from "date-fns/locale/pt-BR";
import {swalQuestion} from "../Swal";
import {delComment, getCommentsById, setComment, updateComment} from "../../services/Comments.service";
import {toast} from "react-toastify";
import {i18n} from "../../translate/i18n";
import {useMutation, useQuery, useQueryClient} from "react-query";
import {Tooltip} from "../Tooltip";
import {getDashboardUsers} from "../../services/Users.service";
import defaultStyle from "../Comments/style";
import {Mention, MentionsInput} from "react-mentions";
import Avatar from "react-avatar";
import {formatDistanceToNow} from "date-fns";
import {enUS} from "date-fns/locale";
import {sendNotificationComment} from "../../services/Mail.service";

function CommentTable({data, tableId, indicatorId = '', usersIndicator = [], indicator = ''}) {

    const { id } = useParams()

    const idParam = indicatorId ? indicatorId : id;

    const queryClient = useQueryClient()
    const { user, language } = useUser()

    let lang = ptBR

    if (language === 'en-US') {
        lang = enUS
    }

    const [comments, setComments] = useState([])
    const [message, setMessage] = useState('')
    const [users, setUsers] = useState([])
    const [mentions, setMentions] = useState('');
    const [newMarkup, setNewMarkup] = useState('');

    useEffect(() => {
        const Request = async () => {
            const response = await getDashboardUsers();
            setUsers(response.map(user => (
                {
                    id: user.id,
                    name: user.username,
                    display: `@${user.username}`
                }
            )))
        }
        Request()
    }, []);

    const handleChange = (ev, newValue, newPlainTextValue, mentions) => {
        const users = mentions.map(item => item.id);
        setMentions(users);
        setMessage(newPlainTextValue);
        setNewMarkup(newValue);
    }

    const {isLoading} = useQuery(["comments", data.param, idParam],
        () => {
            return getCommentsById(idParam, data.param)
        }, {
            onSuccess: (response) => {
                setComments(response)
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: true
        }
    )

    const addComment = async () => {
        const dataComment = {
            'username': user.username,
            'profile' : user.profile,
            'mentions': mentions.toString(),
            'user_id': user.id,
            'comment': message,
            'resolved': false,
            'indicator_id': idParam,
            'type_input': data.param
        }

        await setComment(dataComment)
            .then(response => {
                queryClient.invalidateQueries(["comments_indicator", idParam])
                queryClient.invalidateQueries(["comments", data.param, idParam])
                queryClient.invalidateQueries(["comments_table", tableId])
                setMessage('')
                setNewMarkup('')

                usersIndicator?.map(userIndicator => {
                    const dataMail = {
                        'username' : userIndicator.username,
                        'email' : userIndicator.email,
                        'indicator': indicator,
                        'user_comment': user.username,
                        'comment': message
                    }

                    sendNotificationComment(dataMail)
                })

                toast.success('Comentário enviado com sucesso!');
            })
            .catch(() => {
                toast.error(i18n.t('error.badRequest'));
            })
    }

    const handleResolve = (id) => {
        swalQuestion(`<b>Deseja marcar este comentário como resolvido?</b>`)
            .then((result) => {
                if (result.isConfirmed) {

                    const data = {
                        id: id,
                        resolved: true
                    }

                    commentUpdateMutations.mutate(data)
                }
            })
    }

    const handleDelete = (id) => {
        swalQuestion(`<b>Deseja excluir este comentário?</b>`)
            .then((result) => {
                if (result.isConfirmed) {
                    commentMutations.mutate(id)
                }
            })
    }

    const commentMutations = useMutation(async (id) => {
            return delComment(id)
        }, {
            onSuccess: (res) => {
                toast.success('Comentário excluído sucesso!');
                queryClient.invalidateQueries(["comments_indicator", idParam])
                queryClient.invalidateQueries(["comments", data.param, idParam])
                queryClient.invalidateQueries(["comments_table", tableId])
            },
            onError: (err) => {
                toast.error(i18n.t('error.badRequest'));
            }
        }
    )

    const commentUpdateMutations = useMutation(async (data) => {
            return updateComment(data.id, data)
        }, {
            onSuccess: (res) => {
                toast.success('Comentário alterado para resolvido!');
                queryClient.invalidateQueries(["comments_indicator", idParam])
                queryClient.invalidateQueries(["comments", data.param, idParam])
                queryClient.invalidateQueries(["comments_table", tableId])
            },
            onError: (err) => {
                toast.error(i18n.t('error.badRequest'));
            }
        }
    )

    return (
        <>
            <div className="d-grid gap-2" style={{maxHeight: "400px", overflowY: "auto", overflowX: "hidden"}}>

                { isLoading &&
                    <div className="text-center py-5 bg-light rounded"> Aguarde...</div>
                }

                { !isLoading && comments.length > 0 ?
                    comments?.map((comment, index) =>
                        <div className="p-2" key={index}>
                            <div className="d-flex justify-content-between mb-2">
                                    <span className="fw-bolder">
                                        {comment.username} - {getProfile(comment.profile)}
                                    </span>
                                <span className="text-muted text-sm">

                                        <Tooltip label={format(new Date(comment.created_at), 'dd/MM/yyyy - HH:mm', {locale: ptBR})}>
                                             <span className="float-end text-sm ml-1">
                                                { formatDistanceToNow(
                                                    new Date(comment.created_at),
                                                    {includeSeconds: true, locale: lang}
                                                )}
                                             </span>
                                        </Tooltip>

                                    { user.id === comment.user_id && !comment.resolved &&
                                        <span role="button" className="pe-4 fs-6" onClick={() => handleDelete(comment.id)}>
                                                 <i className="bi bi-trash text-danger"/>
                                            </span>
                                    }
                                    </span>
                            </div>
                            <div className="row">
                                <div className="col-11">
                                    <div className={`${comment.resolved ? 'success-light' : 'warning-light'} rounded p-3`}>
                                        {comment.comment}
                                    </div>
                                </div>
                                <div className="col-1">
                                    {comment.resolved
                                        ?     <Tooltip label={`Resolvido em: ${format(new Date(comment.updated_at), 'dd/MM/yyyy - HH:mm', {locale: ptBR})}`}>
                                            <button className="btn btn-success">
                                                <i className="bi bi-hand-thumbs-up" />
                                            </button>
                                        </Tooltip>

                                        :   <button className="btn btn-warning" onClick={() => handleResolve(comment.id)}>
                                            <i className="bi bi-hand-thumbs-up" />
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    )
                    : !isLoading && <div className="text-center py-5 bg-light rounded"> Nenhum comentário foi adicionado a este campo</div>
                }
            </div>

            <div className="px-3">
                <div className="row py-3 border-top mt-4">
                    <div className="col-xs-9 col-md-10">
                        <div className="multiple-triggers">

                            <MentionsInput
                                value={newMarkup}
                                onChange={handleChange}
                                style={defaultStyle}
                                placeholder={""}
                                a11ySuggestionsListLabel={""}
                            >
                                <Mention
                                    markup="[__display__](__id__)"
                                    trigger="@"
                                    data={users}
                                    renderSuggestion={(
                                        suggestion,
                                        search,
                                        highlightedDisplay,
                                        index,
                                        focused
                                    ) => (
                                        <div className={`user ${focused ? 'focused' : ''}`}>
                                            <Avatar name={suggestion.name} className="me-2" round={true}
                                                    size={25}/>
                                            {suggestion.name}
                                        </div>
                                    )}
                                    style={{backgroundColor: '#e9ecef', top: "-155px"}}
                                    appendSpaceOnAdd={true}
                                />

                            </MentionsInput>
                        </div>
                    </div>
                    <div className="col-xs-3 col-md-2">
                        <button className={`btn btn-outline-secondary ${ !message && 'disabled' } `} onClick={() => addComment()}>
                            Comentar
                        </button>
                    </div>
                </div>
            </div>

        </>
    )

}

export default CommentTable
